// import React, { useCallback, useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { Modal, Button, Dropdown } from 'antd'
// import { ExclamationCircleOutlined, DownOutlined} from '@ant-design/icons'
// import { crmManageAccount, reload } from '../../utils/utils'
// import api from '../../https/api'
// const {account} = crmManageAccount()

// export default function Logout() {

//   const navigate = useNavigate()
//   const [modal, contextHolder] = Modal.useModal();
//   const [items,setItems] = useState([])

//   const getQuestionList = useCallback( async (account) => {
//       if(items.length > 0) return
//       const {data:{data}} = await api.getRoleSwitching({name:account})
//       setItems(data)
//   },[items.length])

//   useEffect(()=>{
//     getQuestionList(account)
//   },[getQuestionList])


//   const logout = () => {
//     modal.confirm({
//       title: '提示',
//       icon: <ExclamationCircleOutlined />,
//       content: '确定要退出吗？',
//       okText: '确认',
//       cancelText: '取消',
//       onOk:() =>{
//         localStorage.removeItem('crm_manage_account')
//         navigate('/login')
//       }
//     });
//   }


//   const onClick = ({ key }) => {
//     if(key === '999'){
//       logout()
//       return
//     }else{
//       modal.confirm({
//         title: '提示',
//         icon: <ExclamationCircleOutlined />,
//         content: '确定要切换角色吗？',
//         okText: '确认',
//         cancelText: '取消',
//         onOk:async () => {
//           const {data:{code,data}} = await api.getSwitchAccounts({id:key})
//           if(code === 0){
//             localStorage.setItem('crm_manage_account',JSON.stringify(data))
//             reload(0)
//             navigate('/index')
//           }
//         }
//       });
//     }
//   };



//   return (
//     // <div className='userinfo'>
//     //   <span>账号:{account}</span>
//     //   &nbsp;&nbsp;

//     //   <Dropdown menu={{ items, onClick }} trigger={['click']}>
//     //   <Space>切换角色<DownOutlined /></Space>
//     //   </Dropdown>

//     //   {/* <Button type="link" onClick={logout}><LogoutOutlined />退出</Button> */}
//     //   {contextHolder}
//     // </div>

//     <div className='userinfo'>
//       <Dropdown  menu={{ items, onClick }} >
//         <Button type='link'>账号：{account}<DownOutlined /></Button>
//       </Dropdown> 
//       {contextHolder}
//     </div>


//   )
// }





import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal, Button, Dropdown } from 'antd'
import { ExclamationCircleOutlined, DownOutlined} from '@ant-design/icons'
import { crmManageAccount, reload } from '../../utils/utils'
import api from '../../https/api'

// 直接调用一次，获取初始账号信息用于显示
const { account: initialAccount } = crmManageAccount()

export default function Logout() {
  const navigate = useNavigate()
  const [modal, contextHolder] = Modal.useModal();
  const [items, setItems] = useState([])

  // 修复：在函数内部获取 account，不再将其作为依赖或参数
  const getQuestionList = useCallback(async () => {
      if (items.length > 0) return;
      // 直接在函数内部调用以获取最新的 account
      const { account } = crmManageAccount();
      const { data: { data } } = await api.getRoleSwitching({ name: account })
      setItems(data)
  }, [items.length]) // 只依赖 items.length

  // 修复：移除了对 account 的依赖
  useEffect(() => {
    getQuestionList()
  }, [getQuestionList])

  const logout = () => {
    modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要退出吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        localStorage.removeItem('crm_manage_account')
        navigate('/login')
      }
    });
  }

  const onClick = ({ key }) => {
    if (key === '999') {
      logout()
      return
    } else {
      modal.confirm({
        title: '提示',
        icon: <ExclamationCircleOutlined />,
        content: '确定要切换角色吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          const { data: { code, data } } = await api.getSwitchAccounts({ id: key })
          if (code === 0) {
            localStorage.setItem('crm_manage_account', JSON.stringify(data))
            reload(0) // 假设 reload 会刷新页面或重新初始化应用
            navigate('/index')
          }
        }
      });
    }
  };

  return (
    <div className='userinfo'>
      {/* 使用初始获取的账号信息进行显示 */}
      <Dropdown menu={{ items, onClick }} >
        <Button type='link'>账号：{initialAccount}<DownOutlined /></Button>
      </Dropdown>
      {contextHolder}
    </div>
  )
}